import { createDownloadableLink } from '@/helpers';
import globalDispatcher from '@/redux/global/actions';
import { isEmpty } from 'lodash';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getAllUsersSuccess: (data) => ({ data }),
  getAllUsers:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().allUsers.paging;
      let { result, status } = await Api.post(`patients/homescreens/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...sortOption,
        ...filterOption,
      });
      status === 200 && allUsersDispatcher.getAllUsersSuccess(result);
    },
  getUserDetail:
    (id, callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`patients/homescreens/${id}`);
      if (status === 200) {
        callback && callback(result);
      }
    },
  editPersonalInfo:
    (id, data) =>
    async ({ Api, customToast }) => {
      //convert lstIdentityUrl
      allUsersDispatcher.setState('loading', true);

      const { status } = await Api.put(`patients/homescreens/user/${id}`, {
        ...data,
      });
      allUsersDispatcher.setState('loading', false);
      status === 200 && customToast('success', 'Edit success');
    },
  getPhysicalHistories:
    (patientId, callback, paging) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().allUsers.paging;
      let { result, status } = await Api.post(`physical-histories/filter`, {
        patientId,
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search: '',
      });
      status === 200 && callback(result);
    },
  setState: (state, value) => ({ state, value }),
  getAllMedicalHistory:
    (id, cb) =>
    async ({ Api, customToast }) => {
      const response = await Api.get(`medical-histories`, {
        patientId: id,
      });
      response.status === 200 && cb && cb(response.result);
    },
  getExportExcel:
    (search) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(
        `patients/homescreens/csv-report`,
        {
          search,
        }
      );
      status === 200 && createDownloadableLink(result, 'user-homescreen');
    },
  getSurveyHistory:
    (params, callback = () => null) =>
    async ({ Api }) => {
      const { patientId, paxScreeningId } = params || {};

      let { result, status } = await Api.get(`survey-histories`, {
        patientId,
        paxScreeningId,
      });
      status === 200 && callback(result);
    },
  updateDoctorPE:
    (prarams, callback) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.put(
        `physical-histories/doctor-submit`,
        prarams
      );
      if (status === 200) {
        callback && callback();
        customToast('success', 'Edit success');
      }
    },
  createDependentProfile:
    (data, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(`family-groups`, data);
      status === 200 && callback && callback();
    },

  approveDependentProfile:
    (dependentUserId, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        `pending-dependent-users/${dependentUserId}/approvals`
      );
      status === 200 && callback && callback();
    },
  disapproveDependentProfile:
    (dependentUserId, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        `pending-dependent-users/${dependentUserId}/rejections`,
        {
          dependentUserId,
          reason: 'text',
        }
      );
      status === 200 && callback && callback();
    },
  getPendingDependentUser:
    (id, callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`pending-dependent-users/${id}`);
      status === 200 && callback && callback(result);
    },
  // api/PendingDependentUsers/{id}
};

const allUsersDispatcher = synthesize('allUsers', mapDispatchToAC);
export default allUsersDispatcher;
